<template>
  <div>
    <form
      class="form form-horizontal"
      role="form"
      @submit.prevent="saveCommodity"
      id="ma-form"
      name="myForm"
      novalidate
    >
      <modal>
        <div slot="header">
          <button type="button" class="close" @click="CloseModal">&times;</button>
          <h2
            class="modal-title"
          >{{(commodity && (commodity.Name==null||commodity.Name==''))?"Commodity":commodity.Name}}</h2>
        </div>
        <div slot="body">
          <div v-if="success_message != '' && success_message!=null">
            <div class="alert alert-success text-center">
              <strong>{{success_message}}</strong>
            </div>
          </div>
          <div v-if="Commodity_message!=null && Commodity_message!=''">
            <div class="alert alert-danger text-center">
              <strong>{{Commodity_message}}</strong>
            </div>
          </div>
          <div v-if="errorMessage!=null && errorMessage!=''">
            <div class="alert alert-danger text-center">
              <strong>{{errorMessage}}</strong>
            </div>
          </div>

          <div class="form-group">
            <div class="col-xs-4">
              <label>
                Code
                <span class="text-danger">*</span>
              </label>

              <input
                type="text"
                class="form-control"
                v-validate="'required|alpha|code-validate|max:250'"
                maxlength="250"
                data-vv-validate-on="blur"
                :class="{'input-validation-error': ((CodeFlags.invalid && !CodeFlags.pristine)||errors.has('Code'))}"
                name="Code"
                autocomplete="off"
                placeholder="Code"
                v-model="commodity.Code"
              />

              <span class="text-danger">{{errors.first('Code')}}</span>
            </div>

            <div class="col-xs-4">
              <label>
                Name
                <span class="text-danger">*</span>
              </label>

              <input
                type="text"
                class="form-control"
                name="Name"
                placeholder="Name"
                maxlength="250"
                v-validate="'required|alpha_spaces|name-validate|max:250'"
                :class="{'input-validation-error': ((NameFlags.invalid && !NameFlags.pristine)||errors.has('Name'))}"
                data-vv-validate-on="blur"
                autocomplete="off"
                v-model="commodity.Name"
              />

              <span class="text-danger">{{errors.first('Name')}}</span>
            </div>
            <div class="col-xs-4">
              <label>
                Unit
                <span class="text-danger">*</span>
              </label>

              <input
                type="text"
                class="form-control"
                name="Unit"
                placeholder="Unit"
                autocomplete="off"
                maxlength="250"
                v-validate="'required|alpha_space_slash||max:250'"
                :class="{'input-validation-error': ((UnitFlags.invalid && !UnitFlags.pristine)||errors.has('Unit'))}"
                data-vv-validate-on="blur"
                v-model="commodity.Unit"
              />

              <span class="text-danger">{{errors.first('Unit')}}</span>
            </div>
          </div>
          <div class="form-group">
            <div class="col-xs-4">
              <label for="deleted">Deleted</label>
              <br />
              <input type="checkbox" id="deleted" v-model="commodity.Deleted" />
            </div>
            <div class="col-xs-4">
              <label for="deleted">Is International</label>
              <br />
              <input type="checkbox" id="International" v-model="commodity.isInternational" />
            </div>
          </div>
          <div class="form-group">
            <div class="col-xs-4">
              <strong v-currentdate></strong>
            </div>
          </div>
        </div>
        <div slot="footer">
          <span class="pull-left text-danger">*Mandatory fields</span>
          <loading v-if="loading"></loading>
          <input type="submit" class="btn btn-primary" value="Save" />
          <button class="btn btn-warning" @click="CloseModal">Cancel</button>
        </div>
      </modal>
    </form>
  </div>
</template>


<script>
import * as ACTIONS from "../../store/actions";
import { mapGetters, mapState } from "vuex";
import VeeValidate, { Validator } from "vee-validate";
import { mapFields } from "vee-validate";
export default {
  data() {
    return {
      success_message: null,
      Commodity_message: null,
      commodity: {
        CommodityId: null,
        Name: "",
        Code: "",
        Unit: "",
        Deleted: "",
        isInternational: false
      }
    };
  },
  props: ["CommodityId"],
  methods: {
    saveCommodity() {
      this.Commodity_message = "";
      this.success_message = "";
      var vm = this;
      this.$validator.validateAll().then(result => {
        if (result) {
          var { commodity } = this;
          var vm = this;
          this.$store
            .dispatch(ACTIONS.COMMODITY_SAVE, commodity)
            .then(res => {
              var { data } = res;

              if (data && data.StatusCode == 200) {
                if (vm.commodity.CommodityId) {
                  vm.success_message = "Commodity modified Successfully";
                } else {
                  vm.success_message = "Commodity modified Successfully";
                }
                setTimeout(function() {
                  vm.success_message = null;
                  vm.CloseModal();
                }, 1500);
              } else if (data && data.StatusCode == 450) {
                var { ResponseData } = data;
                if (ResponseData) {
                  for (var prop in ResponseData) {
                    vm.$validator.errors.add({
                      field: prop,
                      msg: ResponseData[prop]
                    });
                  }
                }
              }
            })
            .catch(err => {
              console.log(err);
            });
        } else {
          vm.Commodity_message = "Please provide correct details.";
          setTimeout(function() {
            vm.Commodity_message = null;
          }, 1800);
        }
      });
    },
    GetData() {
      var vm = this;
      this.$store
        .dispatch(ACTIONS.COMMODITY_GET, this.CommodityId)
        .then(res => {
          var { data } = res;

          if (data && data.StatusCode == 200) {
            var { commodity } = data.ResponseData;
            //vm.commodity ='';
            vm.commodity.CommodityId = commodity.Id;
            vm.commodity.Name = commodity.Name;
            vm.commodity.Code = commodity.Code;
            vm.commodity.Unit = commodity.Unit;
            vm.commodity.Deleted = commodity.Deleted == 1 ? true : false;
            vm.commodity.isInternational = commodity.ISINTERNATIONAL;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    CloseModal() {
      this.$emit("Close");
    }
  },
  computed: {
    ...mapGetters({
      errorMessage: "CommodityErrorMessage",
      loading: "CommoditysaveLoading"
    }),
    ...mapFields({
      CodeFlags: "Code",
      NameFlags: "Name",
      UnitFlags: "Unit"
    })
  },
  beforeMount() {
    if (this.CommodityId) {
      this.commodity.CommodityId = this.CommodityId;
      this.GetData();
    }
  },
  created() {
    var vm = this;
    VeeValidate.Validator.extend("name-validate", {
      validate: function(value, obj) {
        if (value) {
          //var Senddata = {id:0, value: value}
          var Senddata = {
            id: vm.CommodityId == null ? 0 : vm.CommodityId,
            value: value,
            Url: "commodities/CheckDuplicateName"
          };
          return vm.$store
            .dispatch(ACTIONS.COMMODITY_CHECK_DUPLICATE, Senddata)
            .then(res => {
              return { valid: res.data };
            })
            .catch(err => {
              return { valid: true };
            });
        }
      },
      getMessage: function(field, params, value) {
        return "*Duplicate Name";
      }
    });

    VeeValidate.Validator.extend("code-validate", {
      validate: function(value, obj) {
        if (value) {
          //var Senddata = {id:0, value: value}
          var Senddata = {
            id: vm.CommodityId == null ? 0 : vm.CommodityId,
            value: value,
            Url: "commodities/CheckDuplicateCode"
          };
          return vm.$store
            .dispatch(ACTIONS.COMMODITY_CHECK_DUPLICATE, Senddata)
            .then(res => {
              return { valid: res.data };
            })
            .catch(err => {
              return { valid: true };
            });
        }
      },
      getMessage: function(field, params, value) {
        return "*Duplicate Code";
      }
    });
  }
};
</script>